// Web key/value storage (localStorage). Same API the app already consumes.
export async function prefGet(key) {
  return localStorage.getItem(key);
}
export async function prefSet(key, value) {
  localStorage.setItem(key, value);
}
export async function prefRemove(key) {
  localStorage.removeItem(key);
}
